const data = {
  DashboardFinanciero: [
    {
      GastosRecibidos: 20,
      PendienteCobro: 10,
      FacturacionEmitida: 70,
      DesgloseVerifactu: [
        {
          DesgloseValores: {
            Estado: 'string',
            Total: 0
          },
          Porcentaje: 15.34
        },
      ],
      DesgloseEstados: [
        {
          Estado: 'string',
          Total: 0
        }
      ],
      ClientesFacturacion: [
        {
          Nombre: 'string',
          Total: 0
        }
      ],
      Fecha: '2026-03'
    }
  ],
  Alertas: [
    {
      Titulo: 'string',
      Detalle: 'string'
    }
  ],
  blnError: false,
  codError: 'string',
  msgError: 'string'
}


  
export default data
  
